import { atom, type Getter, type SetStateAction } from 'jotai'

import { exists, safeGetLocalStorageItem } from '~/utils'

export const createAtomWithLocalStorage = <Value>(
  getKey: (get: Getter) => string,
) => {
  const keyAtom = atom(getKey)
  const symbolAtom = atom<symbol>(Symbol())

  return atom(
    (get) => {
      get(symbolAtom)
      const key = get(keyAtom)

      return safeGetLocalStorageItem<Value>(key)
    },
    (get, set, update: SetStateAction<Value | undefined>) => {
      const key = get(keyAtom)
      const getNewValue = () => {
        if (typeof update === 'function') {
          const updateFn = update as (prev: Value | undefined) => Value
          const oldValue = safeGetLocalStorageItem<Value>(key)

          return updateFn(oldValue)
        } else {
          return update
        }
      }
      const newValue = getNewValue()

      if (exists(newValue)) {
        localStorage.setItem(key, JSON.stringify(newValue))
      } else {
        localStorage.removeItem(key)
      }
      set(symbolAtom, Symbol())
    },
  )
}
